import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/useAuth';
import ProtectedRoute from './auth/ProtectedRoute';
import Login from './pages/Login';
import Callback from './pages/Callback';
import Dashboard from './pages/Dashboard';
import ProviderSignup from './pages/provider/ProviderSignup';
import ProviderLogin from './pages/provider/ProviderLogin';
import ProviderVerify from './pages/provider/ProviderVerify';
import ProviderForgot from './pages/provider/ProviderForgot';
import ProviderReset from './pages/provider/ProviderReset';
import ProviderDashboard from './pages/provider/ProviderDashboard';
import ProviderPaymentSetup from './pages/provider/ProviderPaymentSetup';
import ProviderBilling from './pages/provider/ProviderBilling';
import ProviderProfile from './pages/provider/ProviderProfile';
import ProviderOwnerManual from './pages/provider/ProviderOwnerManual';
import ProviderTerms from './pages/provider/ProviderTerms';
import ProviderPrivacy from './pages/provider/ProviderPrivacy';
import ProviderCookies from './pages/provider/ProviderCookies';
import LandingVisibilitySync from './components/LandingVisibilitySync';

function App() {
  return (
    <AuthProvider>
      <Router>
        <LandingVisibilitySync />
        <div className="App">
          <Routes>
            {/* Provider Portal Routes (no Cognito required) */}
            <Route path="/provider/terms" element={<ProviderTerms />} />
            <Route path="/provider/privacy" element={<ProviderPrivacy />} />
            <Route path="/provider/cookies" element={<ProviderCookies />} />
            <Route path="/provider/signup" element={<ProviderSignup />} />
            <Route path="/provider/login" element={<ProviderLogin />} />
            <Route path="/provider/verify" element={<ProviderVerify />} />
            <Route path="/provider/forgot" element={<ProviderForgot />} />
            <Route path="/provider/reset" element={<ProviderReset />} />
            <Route path="/provider/payment-setup" element={<ProviderPaymentSetup />} />
            <Route path="/provider/billing" element={<ProviderBilling />} />
            <Route path="/provider/profile" element={<ProviderProfile />} />
            <Route path="/provider/manual" element={<ProviderOwnerManual />} />
            <Route path="/provider/" element={<ProviderDashboard />} />
            <Route path="/provider" element={<Navigate to="/provider/" replace />} />
            
            {/* Legacy routes (with Cognito - can be removed later) */}
            <Route path="/login" element={<Login />} />
            <Route path="/callback" element={<Callback />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            
            {/* Root path shows landing page (handled by index.html) */}
            <Route path="/" element={null} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
